module.exports = __webpack_public_path__ + "img/highlights1.03cbc3c0.png";